import { ChangeDetectorRef, Component, ElementRef, EventEmitter, inject, Input, OnDestroy, OnInit, Output, Renderer2, signal, ViewChild, ViewContainerRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EntryPaymentsService } from '../../data-access/entryPayments.service';
import { mergeMap, of, retry, Subject, takeUntil, throwError } from 'rxjs';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { OnboardErrorDialogComponent } from '../onboard-error-dialog/onboard-error-dialog.component';


const paypalIife = `
  console.log('Paypal Executed');
  (function(d, s, id) {
    var js, ref = d.getElementsByTagName(s)[0];
    if (!d.getElementById(id)) {
      js = d.createElement(s);
      js.id = id;
      js.async = true;
      js.src = "https://www.paypal.com/webapps/merchantboarding/js/lib/lightbox/partner.js";
      ref.parentNode.insertBefore(js, ref);
    }
  }(document, "script", "paypal-js"));
`;

@Component({
  selector: 'equine-ui-nx-onboard-button',
  standalone: true,
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
    MatIconModule,
    MatButtonModule,
    MatDialogModule
  ],
  providers: [
    EntryPaymentsService
  ],
  templateUrl: './onboard-button.component.html',
  styleUrl: './onboard-button.component.scss',
})
export class OnboardButtonComponent implements OnInit, OnDestroy {

  // Show Id is required!!!
  @Input({required: true}) showId!: string;
  @Input() redirectUrl!: string;
  @Input() fromOnboard = false;
  @Output() onboarded = new EventEmitter<void>();

  private entryPaymentsService = inject(EntryPaymentsService);
  private dialog = inject(MatDialog);
  private unsubscribe$ = new Subject<void>();

  loading = signal(true);
  hasLink = signal(false);
  error = signal('');
  linkData = signal<any>(null);

  onboardErrors = signal<{type: string, message: string}[]>([]);

  onBoardUrl!: string;

  public script = paypalIife;

  // This mess is for loading the script of paypal
  container!: any;
  @ViewChild('scriptDiv') set assetInput(elRef: ElementRef) {
    this.container = elRef;
  }

  showRetryButton = false;

  poll: any;

  constructor(private renderer: Renderer2, private changeDetectorRef: ChangeDetectorRef) {}

  ngOnInit() {
    this.checkLink(true, false);
  }

  checkLink(getLink: boolean, fromPoll: boolean) {
    this.entryPaymentsService.isShowRegistered(this.showId)
      .pipe(
        takeUntil(this.unsubscribe$),
        mergeMap(resp => resp.found ? of(resp) : throwError(() => resp)),
        retry({ count: fromPoll ? 1: 5, delay: 200 })
      )
      .subscribe({
        next: (response) => {
          if (response.found) {
            this.linkData.set(response.link);
            this.hasLink.set(true);
            this.loading.set(false);
            this.onboardErrors.set(response.link.errors);
            this.error.set('');
            this.unsubscribe();
            clearInterval(this.poll);

            if (this.onboardErrors().length) {
              this.openErrorDialog();
            } else {
              this.onboarded.emit();
            }
          } else {
            if (getLink && !response.link) {
              this.getOnboardingLink();
            }
          }
        },
        error: (error) => {
          debugger
          this.loading.set(false);
          if (error.found === undefined) {
            this.error.set('An error ocurred.');
          } else {
            if (getLink) {
              this.getOnboardingLink();
            }
          }
        }
      });
  }

  getOnboardingLink() {
    this.entryPaymentsService.getOnboardingLink(this.showId, this.redirectUrl)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (response) => {
          this.onBoardUrl = response.href;
          this.changeDetectorRef.detectChanges();
          this.loading.set(false);
          clearInterval(this.poll);
          setTimeout( () => this.addScript());
        },
        error: (error) => {
          debugger
          this.loading.set(false);
          this.error.set('An error ocurred getting onboard link from Paypal.');
        }
      });
  }

  addScript() {
    const script = this.renderer.createElement('script');
    script.type = 'text/javascript';
    // script.src = paypalIife; // For external scripts
    script.text = paypalIife; // For inline scripts
    this.renderer.appendChild(this.container.nativeElement, script);
  }

  markAsClicked() {
    setTimeout(() => {
      this.showRetryButton = true;
    }, 2000);

    this.startPoll();
  }

  checkAgain() {
    this.checkLink(false, false);
    this.loading.set(true);
  }

  tryAgain() {
    this.checkLink(true, false);
    this.loading.set(true);
  }

  startPoll() {
    this.poll = setInterval(() => {
      this.checkLink(false, true);
    }, 5000);
  }

  checkErrorsAgain() {
    this.entryPaymentsService.updateLinkWithMerchantId(this.showId)
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe({
        next: (response) => {
          this.onboardErrors.set(response.errors);
          if (this.onboardErrors().length) {
            this.openErrorDialog();
          } else {
            this.onboarded.emit();
          }
        }
      })
  }

  openErrorDialog() {
    this.dialog.open(OnboardErrorDialogComponent, {
      maxWidth: '650px',
      data: {
        errors: this.onboardErrors()
      }
    });
  }

  ngOnDestroy(): void {
    this.unsubscribe();
  }

  unsubscribe() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

}
